export enum LANGUAGES {
  uz = "uz",
  ru = "ru",
  en = "eng",
}
